module.exports = __webpack_public_path__ + "img/rightBottom.c12ea308.png";